import templateToJsx from "@lib/templateToJsx";

const CredexUserPromoBannerExtraInfoLabel = ({
  firstName,
  credexConfig,
  installmentValue,
}) => (
  <div className="flex flex-col">
    {firstName && credexConfig && (
      <div className="text-[14px] font-medium">
        {templateToJsx(credexConfig.productPageLabel.userPromo, {
          firstName,
          promoRates: credexConfig.promoRates,
          promoInterest: <strong>{credexConfig.promoInterest}</strong>,
          installmentValue: <strong>{installmentValue}</strong>,
        })}
      </div>
    )}

    {credexConfig.bannerSubTitle && (
      <div className="text-[12px]">{credexConfig.bannerSubTitle}</div>
    )}
  </div>
);

export default CredexUserPromoBannerExtraInfoLabel;
